import React from 'react';
import { List, Datagrid, TextField, EditButton, DeleteButton } from 'react-admin';
import { DEFAULT_LIST_PERPAGE } from '../utils/constants';

export const ProductFeatureList = (props) => (
    <List {...props} perPage={DEFAULT_LIST_PERPAGE}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="display_name" label="Display Name" />
            <TextField source="name" label="Internal Name" />
            <TextField source="description" />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

